import { render, staticRenderFns } from "./investorBusinessFile.vue?vue&type=template&id=653f7652"
import script from "./investorBusinessFile.vue?vue&type=script&lang=js"
export * from "./investorBusinessFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports